export default __webpack_public_path__ + "static/media/PreviewOne.f226014b.gif";